import { Skeleton, Typography } from "antd";
import React from "react";
import TextDateTimeRelative from "templates/TextDateTimeRelative";

const { Text } = Typography;

type Props = {
  isLoading: boolean;
  date_created: number;
  style?: React.CSSProperties | undefined;
};
const styles = {
  timestamp: {
    color: "#898889",
    fontSize: "12px",
  },
};
const Timestamp = ({
  isLoading,
  date_created,
  style = { width: "100%" },
}: Props) => {
  return (
    <div style={{ ...style }}>
      {isLoading ? (
        <Skeleton paragraph={{ rows: 0 }} />
      ) : (
        // <Text style={{ ...styles.timestamp }}>{date_created}</Text>
        <TextDateTimeRelative ts={date_created}></TextDateTimeRelative>
      )}
    </div>
  );
};

export default Timestamp;
